import {IsString} from 'class-validator';

export class WorkspaceMemberUpdateDto {
  @IsString()
  displayName!: string;
}
